import { render, staticRenderFns } from "./mentions.vue?vue&type=template&id=142423a2&scoped=true"
import script from "./mentions.vue?vue&type=script&lang=js"
export * from "./mentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142423a2",
  null
  
)

export default component.exports